import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, tap, shareReplay, catchError } from 'rxjs';
import { API } from '../constants/api-endpoints';

export type FeatureFlags = Record<string, boolean>;

@Injectable({ providedIn: 'root' })
export class FeatureService {
  private readonly http = inject(HttpClient);

  private flags: FeatureFlags = {};
  private loaded = false;
  private inFlight$?: Observable<FeatureFlags>;

  private readonly flagsSubject = new BehaviorSubject<FeatureFlags>({});
  readonly flags$ = this.flagsSubject.asObservable();

  /** Carrega as flags uma unica vez (cache). Seguro chamar em toda navegacao. */
  ensureLoaded(): Observable<FeatureFlags> {
    if (this.loaded) return of(this.flags);
    if (this.inFlight$) return this.inFlight$;

    this.inFlight$ = this.http.get<FeatureFlags>(API.features.base).pipe(
      tap((flags) => this.setFlags(flags ?? {})),
      catchError(() => {
        // Falha ao buscar nao pode travar o app: assume tudo OFF.
        this.setFlags({});
        return of(this.flags);
      }),
      shareReplay(1)
    );
    return this.inFlight$;
  }

  /** Checagem sincrona (usar apos ensureLoaded). */
  isEnabled(name: string): boolean {
    return this.flags[name] === true;
  }

  /** Forca recarregar (ex: apos novo login). */
  reload(): Observable<FeatureFlags> {
    this.loaded = false;
    this.inFlight$ = undefined;
    return this.ensureLoaded();
  }

  private setFlags(flags: FeatureFlags): void {
    this.flags = flags;
    this.loaded = true;
    this.flagsSubject.next(flags);
  }
}
